import { forwardRef } from "react";
import { gql } from "utils/urql";
import ArticleInlineImageFigure from "./ArticleInlineImageFigure";
import { ArticleWellInlineImageFragment } from "types/api";

const ArticleWellInlineImage = forwardRef<
  HTMLElement,
  ArticleWellInlineImageFragment
>(function ArticleWellInlineImage(
  { url, srcSet, width, height, crop, ...props },
  ref
) {
  const sizes = crop
    ? [
        "(min-width: 729px) 655px",
        "(min-width: 576px) calc(100vw - 48px)",
        "100vw",
      ].join(", ")
    : undefined;
  if (crop) {
    url = crop.url;
    width = crop.width;
    height = crop.height;
    srcSet = crop.srcSet;
  }
  return (
    <ArticleInlineImageFigure
      ref={ref}
      url={url}
      srcSet={srcSet}
      width={width}
      height={height}
      sizes={sizes}
      {...props}
    />
  );
});

ArticleWellInlineImage.fragment = gql`
  ${ArticleInlineImageFigure.fragment}

  fragment articleWellInlineImage on ArticleWellInlineImage {
    ...articleInlineImageFigure
    crop(width: 655, sizes: ["655w", "750w", "850w", "928w", "1310w"]) {
      url
      width
      height
      srcSet
    }
    clickthroughUrl
  }
`;

export default ArticleWellInlineImage;
